import { render, staticRenderFns } from "./SoundActivity.vue?vue&type=template&id=2a77dc8b&scoped=true"
import script from "./SoundActivity.vue?vue&type=script&lang=js"
export * from "./SoundActivity.vue?vue&type=script&lang=js"
import style0 from "./SoundActivity.vue?vue&type=style&index=0&id=2a77dc8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a77dc8b",
  null
  
)

export default component.exports